module.exports = __webpack_public_path__ + "static/dedicatedDesk-50ece59808c4f2324dab54b2fbafab80.jpg";